import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[#108981] text-white",
        secondary:
          "border-slate-200 bg-slate-100 text-slate-700",
        destructive:
          "border-transparent bg-red-100 text-red-700",
        outline: 
          "border-slate-200 text-slate-600 bg-white",
        // Status variants
        success:
          "border-emerald-200/50 bg-emerald-50 text-emerald-700",
        warning:
          "border-amber-200/50 bg-amber-50 text-amber-700",
        danger:
          "border-red-200/50 bg-red-50 text-red-700",
        info:
          "border-blue-200/50 bg-blue-50 text-blue-700",
        // Financial status
        paid:
          "border-emerald-200/50 bg-emerald-50 text-emerald-700",
        pending:
          "border-amber-200/50 bg-amber-50 text-amber-700",
        overdue:
          "border-red-200/50 bg-red-50 text-red-700",
        draft:
          "border-slate-200 bg-slate-50 text-slate-600",
        // Priority variants
        critical:
          "border-red-300 bg-red-100 text-red-800 font-semibold",
        high:
          "border-orange-200/50 bg-orange-50 text-orange-700",
        medium:
          "border-amber-200/50 bg-amber-50 text-amber-700",
        low:
          "border-blue-200/50 bg-blue-50 text-blue-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<span className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
